export default __webpack_public_path__ + "static/media/google-g.960c670a.png";